@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div
  class="projectable-form-wrapper frontdoor-form ipsec-form-page"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View IPsec Share: ' : 'Create New IPsec Share'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [showHeaderToggle]="false"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container ipsec-form-body">
      <p class="ipsec-form-lead form-group-row">
        @if (isEditing) {
          Review routing, agent binding, and how traffic reaches your workload through the IPsec tunnel.
        } @else {
          Map a Frontdoor agent and IPsec tunnel to an internal target. Fields marked required must be set before save.
        }
      </p>
      <div class="share-layout form-group-row">
        <div class="share-row">
          <div class="form-group-column half">
            <div class="ipsec-form-panel">
              <lib-form-field-container [title]="'Share Details'">
                <div class="stacked-fields">

                  <div class="field-row">
                    <div class="field-label">
                      Name
                      @if (!isEditing) { <span class="field-label-suffix">REQUIRED</span> }
                    </div>
                    <input
                      class="form-field-input ipsec-form-input"
                      placeholder="Enter a name for this share"
                      [ngClass]="{error: nameError}"
                      [(ngModel)]="formData.name"
                      [attr.autofocus]="!isEditing ? '' : null"
                    />
                    <span [hidden]="!nameError" class="err">{{ nameErrorMessage }}</span>
                  </div>

                  <div class="field-row">
                    <div class="field-label">
                      Hosting Frontdoor Agent
                      @if (!isEditing) { <span class="field-label-suffix">REQUIRED</span> }
                    </div>
                    <div class="field-control">
                      <app-filter-select
                        [options]="agentList"
                        [(ngModel)]="formData.envZId"
                        placeholder="Select an Agent"
                        optionValue="zId"
                        optionLabel="description"
                        style="color: var(--tableText)"
                      ></app-filter-select>
                    </div>
                    <span [hidden]="!agentError" class="err">{{ agentErrorMessage }}</span>
                  </div>

                  <div class="field-row">
                    <div class="field-label">
                      IPsec Tunnel
                      @if (!isEditing) { <span class="field-label-suffix">REQUIRED</span> }
                    </div>
                    <div class="field-control">
                      <app-filter-select
                        [options]="ipsecTunnelList"
                        [(ngModel)]="formData.ipsecTunnelId"
                        placeholder="Select an IPsec Tunnel"
                        optionValue="id"
                        optionLabel="tunnelSelectLabel"
                        style="color: var(--tableText)"
                      ></app-filter-select>
                    </div>
                    <span [hidden]="!ipsecTunnelError" class="err">{{ ipsecTunnelErrorMessage }}</span>
                  </div>

                  <div class="field-row">
                    <div class="field-label">
                      Target
                      @if (!isEditing) { <span class="field-label-suffix">REQUIRED</span> }
                    </div>
                    @if (!isEditing) {
                      <input
                        class="form-field-input ipsec-form-input"
                        [(ngModel)]="formData.target"
                        placeholder="Enter target address and port (e.g. 172.31.10.5:3306)"
                        [ngClass]="{error: targetError}"
                      />
                      <span [hidden]="!targetError" class="err">{{ targetErrorMessage }}</span>
                    }
                    @if (isEditing) {
                      <span class="field-value field-value--mono">{{ formData.target }}</span>
                    }
                  </div>

                  <div class="field-row">
                    <div class="field-label">
                      Ingress Port
                      @if (!isEditing) { <span class="field-label-suffix">REQUIRED</span> }
                    </div>
                    @if (!isEditing) {
                      <input
                        class="form-field-input ipsec-form-input"
                        type="number"
                        [(ngModel)]="formData.ingressPort"
                        placeholder="e.g. 8443"
                        [ngClass]="{error: ingressPortError}"
                      />
                      <span [hidden]="!ingressPortError" class="err">{{ ingressPortErrorMessage }}</span>
                    }
                    @if (isEditing) {
                      <span class="field-value field-value--mono">{{ formData.ingressPort }}</span>
                    }
                  </div>

                </div>
              </lib-form-field-container>
            </div>
          </div>

          <div class="form-group-column half">
            <div class="ipsec-form-panel ipsec-form-panel--accent">
              <lib-form-field-container [title]="'Connection'">
                <div class="stacked-fields">

                  @if (isEditing) {
                    <div class="field-row">
                      <div class="field-label">Status</div>
                      <span class="status-pill" [attr.data-status]="(formData.status || '').toLowerCase()">{{ formData.status }}</span>
                    </div>

                    <div class="field-row">
                      <div class="field-label">Access</div>
                      <span class="field-value field-value--endpoint">{{ accessAddress || '—' }}</span>
                    </div>
                  }

                  @if (!isEditing) {
                    <div class="field-row">
                      <div class="field-label-info ipsec-form-callout">
                        After you create this share, status and access address appear here.
                      </div>
                    </div>
                  }

                </div>
              </lib-form-field-container>
            </div>
          </div>
        </div>

        @if (isEditing) {
          <div class="share-row">
            <div class="form-group-column" style="flex: 1 1 100%; min-width: 0; width: 100%;">
              <div class="ipsec-form-panel">
                <lib-form-field-container [title]="'Metrics'">
                  <app-rx-tx-timeline
                    [samples]="metricSamples"
                    [loading]="metricsLoading"
                    height="14rem"
                  ></app-rx-tx-timeline>
                </lib-form-field-container>
              </div>
            </div>
          </div>
        }
      </div>

  </div>
</div>
